import { useESSnackbar } from '@energy-stacks/core/ui';
import { useGetPlantQuery } from '@energy-stacks/fleet/feature-business-accounts-data';
import { useAppSelector } from '@energy-stacks/fleet/store';
import { useEffect, useMemo, useRef } from 'react';

export const useSelectedPlant = () => {
  const selectedPlantId = useAppSelector(
    (state) => state.plant.selectedPlantId
  );
  const { showSnackbar } = useESSnackbar();
  const isErrorShownRef = useRef(false);

  const { data, isError } = useGetPlantQuery(selectedPlantId ?? '', {
    skip: !selectedPlantId,
  });

  useEffect(() => {
    if (isError && !isErrorShownRef.current) {
      showSnackbar('error', 'getPlantAddressError', 'businessAccounts');
      isErrorShownRef.current = true;
    }
  }, [isError, showSnackbar]);

  return useMemo(() => data, [data]);
};
